module.exports = __webpack_public_path__ + "img/delete_forever.18d9109d.svg";